export interface Query<TKey extends string = string, T = unknown, TResult = unknown> {
  name: TKey;
  payload: T;
}

export const QueryHandlerFactorySymbol = Symbol.for('StoreQueryHandlerFactory');
export const QueryHandlerSymbol = Symbol.for('StoreQueryHandler');

export interface QueryHandler<T> {
  execute(query: T extends Query<string, infer X> ? X : never): Promise<T extends Query<string, any, infer X> ? X : never>;
}

export function createQuery<T>(
  name: T extends Query<infer X, any> ? X : never,
  payload: T extends Query<string, infer X> ? X : never):
Query<T extends Query<infer X, any, any> ? X : never, T extends Query<string, infer X, any> ? X : never,
T extends Query<string, any, infer X> ? X : never> {
  return {
    name,
    payload
  };
}

